<template>
  <div>
    <headerSection :exam_type="reportData?.key" />

    <div class="container py-4">
      <div class="d-md-flex mb-2">
        <div class="d-flex flex-1 border-bottom border-blue-main-toeic">
          <a class="p-2 d-inline-block font-bold pointer mr-2 border border-blue-main-toeic" @click="selectEn = true" :class="{ 'bg-blue-lighter-toeic text-white': selectEn, 'text-blue-main-toeic': !selectEn }">英文成績證明</a>
          <a class="p-2 d-inline-block font-bold pointer mr-2 border border-blue-main-toeic" @click="selectEn = false" :class="{ 'bg-blue-lighter-toeic text-white': !selectEn, 'text-blue-main-toeic': selectEn }">中文成績證明</a>
        </div>
        <div class="text-center mt-4 mt-md-0 d-flex justify-content-end">
          <a @click="downloadReport" class="bg-blue-lighter-toeic text-white px-4 py-2 d-inline-block font-bold text-lg pointer mx-2 rounded pointer">證書下載</a>
          <router-link :to="{ name: 'detailed_explanation', params: { practice_type: $route.params.practice_type, record_id: $route.params.record_id } }" class="bg-blue-lighter-toeic text-white px-4 py-2 d-inline-block font-bold text-lg pointer mx-2 rounded">查看詳解</router-link>
        </div>
      </div>
      <!-- Title -->
      <div class="" ref="captureRef" id="report_inner">
        <div class="mb-2 p-2 px-2 bg-white">
          <p class="text-blue-main-toeic text-left mb-1 font-semibold">Speaking Test</p>
          <h3 class="text-center font-bold">{{ reportData?.key === 'toeic_bridge' ? 'Toeic Bridge' : 'Toeic' }} SCORE CERTIFICATE</h3>
        </div>
        <!-- Top Section -->
        <div class="row mx-0 mb-2">
          <!-- Left Info -->
          <div class="col-md-6 text-left bg-white">
            <div class="">
              <div class="py-3">
                <div class="border-bottom pb-1">NAME</div>
                <div class="mb-3 text-lg font-bold" v-if="personalData">{{ personalData.name }}</div>

                <div class="border-bottom pb-1">TEST DATE (yyyy/mm/dd)</div>
                <div class="text-lg font-bold">{{ reportData?.created_at }}</div>
              </div>

              <div class="py-3">
                <div class="text-blue-main-toeic text-xl font-semibold mb-1">{{ selectEn ?  'Pronunciation' : '發音 (Pronunciation)' }} : <span class="text-orange-main-toeic">{{ selectEn ? pronunciationAndProsody.pron.label_en : pronunciationAndProsody.pron.label_zh }}</span></div>
                <p class="text-lg font-semibold mb-3">{{ selectEn ? pronunciationAndProsody.pron.en : pronunciationAndProsody.pron.zh }}</p>

                <div class="text-blue-main-toeic text-xl font-semibold mb-1">{{ selectEn ?  'Intonation and Stress' : '語調重音 (Intonation & Stress)' }} : <span class="text-orange-main-toeic">{{ selectEn ? pronunciationAndProsody.prosody.label_en : pronunciationAndProsody.prosody.label_zh }}</span></div>
                <p class="text-lg font-semibold">{{ selectEn ? pronunciationAndProsody.prosody.en : pronunciationAndProsody.prosody.zh }}</p>
              </div>
            </div>
          </div>

          <!-- Right Score -->
          <div class="col-md-6 text-center bg-white">
            <div class="p-3">
              <div class="d-flex justify-content-center mb-5 block">
                <gaugeCanvas v-if="reportData" :total_score="reportData?.total_score || 0" class="w-100" :maxScore="reportData.key === 'toeic' ? 200 : 50"  />
              </div>
              <div class="block pt-5">
                <!-- <div class="text-xl border-bottom pb-2 rounded">Speaking proficiency level is {{ this.reportData?.level || 1 }}.</div> -->
                <div class="font-weight-bold text-orange-main-toeic mt-2 text-2xl rounded" v-if="current_CEFR_level">CEFR {{ current_CEFR_level.level }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- Bottom Section -->
        <div class="row mx-0">
          <!-- Radar chart placeholder -->
          <!-- <div class="col-md-6 text-lg pb-3 bg-white">
            <div class="p-2 w-auto d-flex">
              <img src="@/assets/image/toeic/toeic_exam/Capability_analysis.png" alt="" class="object-contain">
            </div>
            <radarChart />
          </div> -->

          <!-- Text Description -->
          <div class="col text-left text-xl bg-white py-3" v-if="currentLevel">
            <p class="font-semibold text-xl">Your scaled score is between {{ currentLevel.scoreRange }}.</p>
            <p class="text-left" v-if="selectEn" v-html="currentLevel.description_en_gpt.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
            <p class="text-left" v-if="!selectEn" v-html="currentLevel.description_zh_gpt.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapActions, mapGetters } from 'vuex'
  import headerSection from '@/components/AiHelper/toeic/headerSection'
  import gaugeCanvas from '@/components/AiHelper/toeic/gaugeCanvas'
  import speakingLevels from '@/components/AiHelper/toeic/speakingLevels.js'
  import api from '@/store/api'
  import html2canvas from 'html2canvas'
  export default {
    name: 'report',
    components: {
      headerSection,
      gaugeCanvas,
    },
    data () {
      return {
        reportData: null,
        selectEn: true,
        speakingLevelsData: speakingLevels,
        personalData: null
      }
    },
    watch: {
    },
    computed: {
      ...mapGetters([
        'remainPoints',
        'auth'
      ]),
      pronunciationAndProsody () {
        const LPronScore = this.reportData?.LPronScore || 0
        const LProsodyScore = this.reportData?.LProsodyScore || 0
        const levelData = this.speakingLevelsData.pronunciation_intonation

        const getLevel = (score, type) => {
          if (score === 3) return levelData[type].high
          if (score === 2) return levelData[type].medium
          return levelData[type].low
        }

        return {
          pron: getLevel(LPronScore, 'Pronunciation'),
          prosody: getLevel(LProsodyScore, 'IntonationAndStress')
        }
      },

      current_CEFR_level () {
        const score = this.reportData?.total_score ?? 0
        let current_CEFR_Data = this.reportData && this.reportData.key === 'toeic' ? this.speakingLevelsData.CEFRLevels.toeic : this.speakingLevelsData.CEFRLevels.bridge

        const key = this.reportData?.type === 'speaking'
          ? 'scoreRange_speaking'
          : 'scoreRange_writing'

        return (
          current_CEFR_Data.find(level => {
            const [min, max] = level[key].split('-').map(Number)
            return score >= min && score <= max
          }) || null
        )
      },

      currentLevel () {
        let score = this.reportData?.total_score || 0
        let currentLevelData = this.reportData && this.reportData.key === 'toeic' ? this.speakingLevelsData.SpeakingLevels.toeic : this.speakingLevelsData.SpeakingLevels.bridge

        if (!currentLevelData || !Array.isArray(currentLevelData)) {
          return null
        }

        return (
          currentLevelData.find(level => {
            const [min, max] = level.scoreRange.split('-').map(Number)
            return score >= min && score <= max
          }) || null
        )
      },

    },
    mounted () {
      this.getData()
      this.getPersonalData()
    },
    methods: {
      ...mapActions({
        doGetPoints: 'getRemainPoints',
        getUser: 'getUser'
      }),
      async getPersonalData () {
        const { data } = await api.get('/me')
        this.personalData = data
      },
      getData () {
        let path = `/assessments/records/${this.$route.params.record_id}`

        api.get(path)
        .then((res) => {
          this.reportData = res.data
        })
        .catch((err) => {
          console.log(err)
        })
      },

      async downloadReport () {
        const el = this.$refs.captureRef
        if (!el) return

        const width = el.scrollWidth
        const height = el.scrollHeight

        const canvas = await html2canvas(el, {
          scrollX: 0,
          scrollY: 0,
          width: width + 20,
          height: height + 20,
          scale: 2,
          backgroundColor: '#ffffff',
          useCORS: true
        })

        const link = document.createElement('a')
        link.download = 'report.png'
        link.href = canvas.toDataURL('image/png')
        link.click()
      }
    }
  }
</script>
<style lang="scss">
a {
  &:hover {
    text-decoration: none !important;
  }
}
</style>
